import { render, staticRenderFns } from "./CustomerSettingsWrapper.vue?vue&type=template&id=1d8b55ee&"
import script from "./CustomerSettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomerSettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports